import { ParameterTypeEnum } from "../enums/parameterType.enum";

export class NodeRecordsRequestModel {
    orgLevelId: string;
    analyteId: string;
}

export class NodeSensorRecordsRequestModel {
    orgLevelId: string;
    analyteId: string;
    endPointId: string;
    dateFilterType: number;
    startDate: number;
    endDate: number;
    includeVideo: boolean;
    sensorAssignmentId?: string;
    parameterTypes?: number[] 
}

export class NodeParameterTypeRequestModel {
    nodeId: string;
    dateFilterType: number;
    startDate: number;
    endDate: number;
}

export class NodeParameterType {
  id: number;
  value: string;
  pushed: boolean;
  selected: boolean;
  hidden?: boolean
}

export class WindDustDistribution {
    dateFilterType: number;
    includeVideo: boolean;
    startDate: number;
    endDate: number;
    analyteId: string;
    endPointId: string;
    orgLevelId: string;
    sensorAssignmentId?: string;
    parameterTypes?: ParameterTypeEnum[];
}
